import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './css/CatGuide.css';
import CatBreedsPage from './guide_pages/CatBreeds';
import StrayCatAdoptionPage from './guide_pages/StrayCatAdoption';
import FeedFrequencyPage from './guide_pages/FeedFrequency';
import CatHomeSaftyPage from './guide_pages/CatHomeSafty';
import KittenOrAdultCatPage from './guide_pages/KittenOrAdultCat';

// 分类数据模型
const categories = {
  preparation: {
    title: '准备阶段',
    subs: {
      breed: {
        title: '品种选择',
        items: [
          '常见猫咪品种',
          '幼猫/成猫选择建议',
          '收养流浪猫注意事项',
          '多猫家庭注意事项',
          '过敏体质友好品种推荐'
        ]
      },
      environment: {
        title: '环境准备',
        items: [
          '安全封窗指南',
          '危险物品排查清单',
          '喵宅区域规划',
          '智能养猫设备推荐'
        ]
      },
      supplies: {
        title: '物资清单',
        items: [
          '猫砂盆与猫砂',
          '食物和水碗',
          '优质猫粮选择',
          '猫抓板/猫爬架',
          '猫咪玩具',
          '猫窝/睡垫',
          '运输箱',
          '梳理工具（梳子、指甲剪）'
        ]
      }
    }
  },
  dailyCare: {
    title: '日常养护',
    subs: {
      diet: {
        title: '饮食管理',
        items: [
          '猫粮选择标准',
          '喂食频率与份量',
          '饮水管理技巧',
          '自制猫饭指南'
        ]
      },
      grooming: {
        title: '清洁护理',
        items: [
          '梳毛技巧（长毛/短毛）',
          '洗澡操作指南',
          '牙齿清洁方法',
          '泪痕处理方案'
        ]
      },
      behavior: {
        title: '行为管理',
        items: [
          '正确使用猫砂盆',
          '抓挠行为引导',
          '社会化训练',
          '外出适应训练'
        ]
      }
    }
  },
  health: {
    title: '健康管理',
    subs: {
      preventive: {
        title: '预防医学',
        items: [
          '疫苗选择及接种计划',
          '体内外驱虫',
          '年度体检项目说明',
          '宠物保险选择'
        ]
      },
      disease: {
        title: '疾病护理',
        items: [
          '常见症状识别（呕吐/腹泻等）',
          '应急处理方案',
          '慢性病管理',
          '术后护理指南'
        ]
      },
      lifecycle: {
        title: '生命周期护理',
        items: [
          '绝育/节育的好处',
          '幼猫发育阶段护理',
          '成年猫保健重点',
          '老年猫特殊需求',
          '临终关怀指南'
        ]
      }
    }
  },
  behavior: {
    title: '行为科学',
    subs: {
      language: {
        title: '肢体语言',
        items: [
          '尾巴动作解析',
          '耳朵姿态解读',
          '了解各种叫声和行为含义',
          '身体姿态分析',
          '眼神交流解读',
          '肢体接触偏好'
        ]
      },
      problems: {
        title: '行为问题与纠正',
        items: [
          '乱抓家具',
          '不使用猫砂盆',
          '过度攻击行为',
          '夜间吵闹',
          '异食癖应对',
          '焦虑表现处理',
          '领地标记对策'
        ]
      }
    }
  },
  social: {
    title: '社会责任',
    subs: {
      science: {
        title: '科学养宠',
        items: [
          '绝育重要性说明',
          '室内养猫优势解析',
          '弃养危害警示',
          '宠物殡葬指南'
        ]
      },
      stray: {
        title: '流浪猫保护',
        items: [
          '安全接触指南',
          'TNR（捕捉、绝育、放归）实施流程',
          '领养注意事项',
          '社区猫管理'
        ]
      },
      rights: {
        title: '权益保护',
        items: [
          '施虐心理成因',
          '虐待行为识别',
          '举报渠道说明',
          '动物保护法规',
          '宠物维权案例'
        ]
      }
    }
  },
  interaction: {
    title: '互动交流',
    subs: {
      support: {
        title: '专业支持',
        items: [
          '在线问诊通道',
          '行为矫正专家',
          '营养师咨询',
          '保险理赔指导'
        ]
      }
    }
  }
};

function CatGuide() {
  const [activeCategory, setActiveCategory] = useState('preparation');
  const [activeSubCategory, setActiveSubCategory] = useState('breed');
  const [expandedCategory, setExpandedCategory] = useState('preparation');

  // 获取分类图标
  const getCategoryIcon = (categoryKey) => {
    const iconMap = {
      preparation: 'paw',
      dailyCare: 'home',
      health: 'heartbeat',
      behavior: 'brain',
      social: 'users',
      interaction: 'comments'
    };
    return iconMap[categoryKey] || 'cat';
  };

  // 切换分类展开/折叠状态
  const toggleCategory = (categoryKey) => {
    // 如果当前分类已展开，则折叠它
    if (expandedCategory === categoryKey) {
      setExpandedCategory('');
    } 
    // 如果当前分类未展开，则展开它（同时自动折叠其他分类）
    else {
      setExpandedCategory(categoryKey);
    }
  };

  // 选择子分类
  const selectSubCategory = (categoryKey, subCategoryKey) => {
    setActiveCategory(categoryKey);
    setActiveSubCategory(subCategoryKey);
    
    // 确保当前分类展开
    setExpandedCategory(categoryKey);
  };

  return (
    <div className="container-fluid mt-3">
      <div className="row">
        {/* 侧边导航栏 */}
        <div className="col-md-3">
          <div className="card shadow-sm" style={{ position: 'sticky', top: '20px' }}>
            <div className="card-body p-0">
              <nav className="nav flex-column" style={{ maxHeight: '80vh', overflowY: 'auto', paddingBottom: '20px' }}>
                {Object.entries(categories).map(([categoryKey, category]) => (
                  <div key={categoryKey} className="nav-item">
                    {/* 主分类按钮 */}
                    <div 
                      className={`nav-link category-link d-flex justify-content-between align-items-center py-3 px-3 ${
                        activeCategory === categoryKey ? 'active-category' : ''
                      }`}
                      onClick={() => toggleCategory(categoryKey)}
                      style={{
                        cursor: 'pointer',
                        borderLeft: '4px solid transparent',
                        backgroundColor: activeCategory === categoryKey ? '#f8f9fa' : 'transparent',
                        fontWeight: activeCategory === categoryKey ? 'bold' : 'normal',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <span>
                        <i className={`fas fa-${getCategoryIcon(categoryKey)} me-2`}></i>
                        {category.title}
                      </span>
                      <span className="badge rounded-pill bg-light text-dark">
                        {expandedCategory === categoryKey ? 
                          <i className="fas fa-chevron-down"></i> : 
                          <i className="fas fa-chevron-right"></i>
                        }
                      </span>
                    </div>
                    
                    {/* 子分类列表 */}
                    {expandedCategory === categoryKey && (
                      <div className="subcategory-container" style={{
                        backgroundColor: '#f8f9fa',
                        overflow: 'hidden',
                        transition: 'max-height 0.3s ease'
                      }}>
                        {Object.entries(category.subs).map(([subKey, sub]) => (
                          <div
                            key={subKey}
                            className={`nav-link subcategory-link py-2 ps-4 pe-3 ${
                              activeCategory === categoryKey && activeSubCategory === subKey ? 'active-subcategory' : ''
                            }`}
                            onClick={() => selectSubCategory(categoryKey, subKey)}
                            style={{
                              cursor: 'pointer',
                              borderLeft: activeCategory === categoryKey && activeSubCategory === subKey ? 
                                '4px solid #28a745' : '4px solid transparent',
                              backgroundColor: activeCategory === categoryKey && activeSubCategory === subKey ? 
                                '#e9ecef' : 'transparent',
                              fontSize: '0.95rem',
                              transition: 'all 0.2s ease'
                            }}
                          >
                            {sub.title}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </nav>
            </div>
          </div>
        </div>

        {/* 主内容区 */}
        <div className="col-md-9">
          {/* 内容标题 */}
          <h3 className="mb-3">
            {categories[activeCategory].title} - {categories[activeCategory].subs[activeSubCategory].title}
          </h3>

          {/* 内容展示 */}
          <div className="accordion" id="contentAccordion">
            {categories[activeCategory].subs[activeSubCategory].items.map((item, index) => (
              <div key={index} className="accordion-item">
                <h2 className="accordion-header">
                  <button 
                    className="accordion-button collapsed" 
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse-${activeCategory}-${activeSubCategory}-${index}`}
                  >
                    {item}
                  </button>
                </h2>
                <div 
                  id={`collapse-${activeCategory}-${activeSubCategory}-${index}`}
                  className="accordion-collapse collapse"
                  data-bs-parent="#contentAccordion"
                >
                  <div className="accordion-body">
                    {item === '常见猫咪品种' ? (
                      <CatBreedsPage />
                    ) : item === '收养流浪猫注意事项' ? (
                      <StrayCatAdoptionPage title={item} />
                    ) : item === '喂食频率与份量' ? (
                      <FeedFrequencyPage title={item} />
                    ) : item === '危险物品排查清单' ? (
                      <CatHomeSaftyPage title={item} />
                    ) : item === '幼猫/成猫选择建议' ? (
                      <KittenOrAdultCatPage title={item} />
                    ) : (
                      <>
                        <p>这里是 {item} 的详细内容...</p>
                        <Link to={`/detail/${activeCategory}/${activeSubCategory}/${index}`} className="btn btn-sm btn-outline-secondary">
                          查看详情
                        </Link>
                      </>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CatGuide;
